var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"newBox"},[_c('div',{staticClass:"doT-one"}),_vm._v(" "),_c('div',{staticClass:"doT-two"}),_vm._v(" "),_c('div',{staticClass:"news"},[_c('p',{staticClass:"news-P-one"},[_vm._v(_vm._s(_vm.$t("i.system.news")))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ac62ae2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/LatestNews.vue
// module id = null
// module chunks = 